import { createRequestHelper } from '@utils/swr'
import { type ProductSearchRequest } from '../types/apiRequest'
import { type ProductSearchResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const { useRequest } = createRequestHelper<FortuneApis['get']['productSearch'], ProductSearchResponse, ProductSearchRequest>({
  client: 'fortune',
  key: (params) => {
    const { code, query } = params || {}
    if (!code || !query) return null
    return `/campaigns/${code}/products/search?q=${query}`
  },
})

export const useApiCampaignProductSearch = useRequest
